<template>
  <v-row
    :ref="`avatarContainer-${this.sectionIndex}`"
    :class="isInIframe ? 'container-comment-avatar embeddable' : 'container-comment-avatar'"
    style="height: 25px"
    id="containerIcon"
    no-gutters
  >
    <v-col
      v-if="
        (iconList !== undefined && iconList !== null && iconList.length > 0) ||
        (emoticonList !== undefined && emoticonList !== null && emoticonList.length > 0 && emoticonList !== '')
      "
      id="colIcon"
    >
      <v-menu
        attach="#containerIcon"
        class="previewCardDetail"
        :transition="isInIframe ? false : 'slide-x-transition'"
        :close-on-content-click="false"
        :close-on-click="$store.getters.commentPlayPreview"
        :nudge-top="isInIframe ? (!isPlayerPause ? '45' : upHere ? '45' : '0') : '45'"
        :nudge-left="nudgeLeft(comment.boxData.time)"
        v-for="(comment, index) in iconList"
        :key="comment.cmId"
        v-model="showCommentPlay[index]"
        top
        z-index="198"
        max-width="182"
      >
        <template v-slot:activator="{ on: menu }">
          <v-avatar
            ref="controlBarIcon"
            v-on="{ ...menu }"
            @click.stop="clickControlbarIcon(comment, index)"
            class="btn-visual-comment"
            :color="comment.userDisplayName | iconBackground"
            :class="{ avatarControlbar: $store.getters.clickCommentId.cmId === comment.cmId }"
            round
            size="20"
            style="cursor: default"
            :style="{
              top: '4px',
              left: `${getPosition(comment.boxData.time, duration, widthOfVideoControlBar)}px`,
              position: 'absolute',
              cursor: 'pointer',
              zIndex: '198',
            }"
          >
            <div class="avatar-bg" v-if="comment.userPicture"></div>
            <span class="white--text cent" style="font-size: 14px" v-if="comment.userPicture === ''">
              {{ comment.userDisplayName | iconFilter }}
            </span>
            <v-img :src="comment.userPicture" v-else />
          </v-avatar>
        </template>

        <div>
          <v-card
            :max-width="isInIframe ? '' : '200px'"
            :class="isInIframe ? 'commentPlayPreview embeddable' : 'commentPlayPreview'"
          >
            <v-list class="pa-0 commentPlayPreview">
              <v-list-item class="pr-0 pt-1 pb-1">
                <v-list-item-avatar style="outline: 0px !important" class="mr-0">
                  <v-avatar
                    class="mr-5"
                    ref="controlBarIcon"
                    @click.stop="clickControlbarIcon(comment)"
                    :color="comment.userDisplayName | iconBackground"
                    round
                    size="26"
                    style="cursor: default; border: 1px solid #1d292f"
                  >
                    <div class="avatar-bg" v-if="comment.userPicture"></div>
                    <span class="white--text cent" style="font-size: 14px" v-if="comment.userPicture === ''">
                      {{ comment.userDisplayName | iconFilter }}
                    </span>
                    <v-img :src="comment.userPicture" v-else />
                  </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content class="pa-0">
                  <v-list-item-title style="font-size: 13px; color: #ccc; font-weight: 400">
                    {{ comment.userDisplayName }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    :style="
                      isInIframe
                        ? 'text-overflow: unset; white-space: normal; font-size: 14px; color: #eee; padding-right: 20px'
                        : 'font-size: 14px; color: #eee; padding-right: 10px'
                    "
                  >
                    {{ comment.cmContent }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </v-menu>

      <!-- emoji list -->
      <v-menu
        :close-on-click="$store.getters.emojiPlayOn"
        attach="#containerIcon"
        transition="slide-x-transition"
        top
        :nudge-top="isInIframe ? (!isPlayerPause ? '50' : upHere ? '50' : '0') : '50'"
        :nudge-left="nudgeLeft(emoji.emojiTime)"
        z-index="198"
        v-for="(emoji, index) in emoticonList"
        :key="index"
        v-model="showEmojiPlay[index]"
      >
        <template v-slot:activator="{ on }">
          <div
            id="svgemoji"
            class="btn-emoji"
            @click.stop="clickEmoji(emoji, index)"
            v-on="on"
            :style="{
              left: `${getPosition(emoji.emojiTime, duration, widthOfVideoControlBar)}px`,
              position: 'absolute',
              cursor: 'pointer',
            }"
          >
            <!-- <component
              class="emoji-svg mt-1"
              size="19"
              width="19px"
              height="19px"
              :is="emoji.type"
              :class="{ avatarControlbarEmoji: $store.getters.clickEmojiId.emojiId === emoji.emojiId }"
            ></component> -->
          </div>
        </template>

        <v-card max-width="200px" class="commentPlayPreview">
          <v-list class="pa-0 commentPlayPreview">
            <v-list-item class="pr-0 pt-2 pb-2">
              <v-list-item-avatar style="outline: 0px !important" class="mr-0">
                <v-avatar
                  class="mr-5"
                  ref="controlBarIcon"
                  @click.stop="clickEmoji(emoji)"
                  :color="emoji.userInfo.userDisplayName || emoji.userInfo.userFullName | iconBackground"
                  round
                  size="26"
                  style="cursor: default"
                >
                  <div class="avatar-bg" v-if="emoji.userInfo.userPicture"></div>
                  <span class="white--text cent" style="font-size: 14px" v-if="emoji.userInfo.userPicture === ''">
                    {{ emoji.userInfo.userDisplayName | iconFilter }}
                  </span>
                  <v-img :src="emoji.userInfo.userPicture" v-else />
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="pa-0">
                <v-list-item-title style="font-size: 13px; color: #ddd; font-weight: 400; margin-left: 5px">
                  {{ emoji.userInfo.userDisplayName }}
                </v-list-item-title>
                <v-list-item-subtitle style="font-size: 12px; color: #eee; margin-top: -5px; margin-left: -5px">
                  <component
                    class="emoji-svg mt-2"
                    size="22"
                    width="22px"
                    height="22px"
                    :is="emoji.type"
                    style="margin-left: 10px"
                  ></component>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>

        <!-- <v-row
          style="background-color: rgb(63 60 60 / 40%)"
          class="py-1 px-3"
          no-gutters
          justify="center"
          align="center"
        >
          <v-col>
            <span style="font-size: 12px; color: white; font-weight: bold; display: inline; white-space: nowrap">
              {{ emoji.userInfo.userDisplayName || emoji.userInfo.userFullName }} reacted with
            </span>
          </v-col>
          <v-col cols="auto">
            <component
              class="emoji-svg mt-2"
              size="22"
              width="22px"
              height="22px"
              :is="emoji.type"
              :class="{ avatarControlbarEmoji: $store.getters.clickEmojiId.emojiId === emoji.emojiId }"
              style="margin-left: 10px"
            ></component>
          </v-col>
        </v-row> -->
      </v-menu>
    </v-col>
    <v-col v-if="modifiedSummaryData" id="wrap-summary">
      <summary-icon
        v-for="(item, idx) in modifiedSummaryData"
        :key="item.sgId + item.timestamps + idx"
        ref="play_icon"
        :item="item"
        style="font-size: 20px"
        :style="{
          left: `${getPosition(item.timestamps, duration, widthOfVideoControlBar)}px`,
          position: 'absolute',
          cursor: 'pointer',
          zIndex: '197',
        }"
        :seekTime="seekTime"
        :iconColor="
          clickedSummaryCard && clickedSummaryCard.topic === item.topic && clickedSummaryTimestamp === item.timestamps
            ? '#FF575F'
            : 'white'
        "
        :modifiedSummaryData="modifiedSummaryData"
      ></summary-icon>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { getEmojiList } from '@/services/emoji'
import { isMobile } from '@/common/lib/strLib'
import FluentEmojiCheckMarkButton from '@/views/meeting/component/emoji/FluentEmojiCheckMarkButton'
import FluentEmojiClappingHands from '@/views/meeting/component/emoji/FluentEmojiClappingHands'
import FluentEmojiThinkingFace from '@/views/meeting/component/emoji/FluentEmojiThinkingFace'
import FluentEmojiSmilingFaceWithTear from '@/views/meeting/component/emoji/FluentEmojiSmilingFaceWithTear'
import FluentEmojiBackhandIndexPointingUp from '@/views/meeting/component/emoji/FluentEmojiBackhandIndexPointingUp'
import FluentEmojiRedHeart from '@/views/meeting/component/emoji/FluentEmojiRedHeart'
import DeleteEmojiDialog from '../../modal/DeleteEmojiDialog.vue'
import FluentEmojiThumbsUp from '@/views/meeting/component/emoji/FluentEmojiThumbsUp.vue'
import FluentEmojiGrinningSquintingFace from '@/views/meeting/component/emoji/FluentEmojiGrinningSquintingFace.vue'
import FluentEmojiLightBulb from '@/views/meeting/component/emoji/FluentEmojiLightBulb.vue'
import SummaryIcon from '@/views/meeting/component/playicons/SummaryIcon.vue'

export default {
  name: 'CommentPlay',
  data() {
    return {
      widthOfVideoControlBar: 0,

      //CommentPlay Preview 보여주기 위한 배열 값
      showCommentPlay: [],
      //EmojiPlay Preview 보여주기 위한 배열 값
      showEmojiPlay: [],
      // Comment Play 시 setTimeout Timer 할당하는 값
      timeOutValue: 0,

      //사용안함
      temp: false,
      emojiList: [],
      emojiListWithType: [],
      //사용 안함
      displayingComments: [],

      //EmojiPlay Preview 시 setTimeout Timer 할당하는 값
      emojiPreviewTimeOutValue: 0,

      //Preview Index 할당하는 값
      activeCommentPreviewIdx: 0,

      //Emoji Preview Index 할당하는 값
      activeEmojiPreviewIdx: 0,

      threshold: 0.5,
    }
  },

  components: {
    FluentEmojiClappingHands,
    FluentEmojiCheckMarkButton,
    FluentEmojiThinkingFace,
    FluentEmojiSmilingFaceWithTear,
    FluentEmojiBackhandIndexPointingUp,
    DeleteEmojiDialog,
    FluentEmojiRedHeart,
    FluentEmojiGrinningSquintingFace,
    FluentEmojiThumbsUp,
    FluentEmojiLightBulb,
    SummaryIcon,
  },

  created() {
    this.$root.$refs[`CommentPlay-${this.sectionIndex}`] = this
  },

  mounted() {
    window.addEventListener('resize', this.getWidth)
    this.widthOfVideoControlBar =
      this.$refs[`avatarContainer-${this.sectionIndex}`] !== undefined &&
      this.$refs[`avatarContainer-${this.sectionIndex}`] !== null
        ? this.$refs[`avatarContainer-${this.sectionIndex}`]?.getBoundingClientRect()?.width
        : 0
    this.$nextTick(() => {
      this.widthOfVideoControlBar = this.getWidth()
    })
    window.addEventListener('resize', this.getWidth)

    const onresize = (dom_elem, callback) => {
      const resizeObserver = new ResizeObserver(() => callback())
      resizeObserver.observe(dom_elem)
    }

    const dom = document.querySelector('#secondPanel')

    onresize(dom, this.getWidth)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth)
  },

  props: ['sectionIndex', 'seekTime', 'upHere'],

  methods: {
    ...mapActions([
      'setSummarySegments',
      'setSummary',
      'setClickedSummaryCard',
      'setClickedSummaryTimestamp',
      'setIsCommentIconClicked',
      'setClickedSummaryCard',
      'setClickedSummaryTimestamp',
      'setIsSummaryPlayOn',
      'setIsSummaryIconClicked',
    ]),

    isSummaryWithinRange(summaryTime, videoTime, threshold) {
      return Math.abs(summaryTime - videoTime) <= threshold
    },

    handleSegmentFound(summarySegment) {
      // console.log('summary hit with that time Mark', summarySegment)

      // if (this.styleRemoveTimeout) {
      //   clearTimeout(this.styleRemoveTimeout)
      // }

      this.setClickedSummaryCard(summarySegment)
      this.setClickedSummaryTimestamp(summarySegment.timestamps)

      // Set a new timeout to remove the styling after 2 seconds
      // if (this.isSummaryPlayOn) {
      //   this.styleRemoveTimeout = setTimeout(() => {
      //     this.removeIconStyling() // Replace this with your method to remove the styling
      //     this.styleRemoveTimeout = null
      //   }, 2000)
      // }
    },

    findSegmentByIndex(modifiedSummaryData, newTime) {
      const index = this.customBinarySearch(modifiedSummaryData, newTime)
      return index !== -1 ? modifiedSummaryData[index] : null
    },

    customBinarySearch(array, target) {
      let left = 0
      let right = array.length - 1

      while (left <= right) {
        const middle = Math.floor((left + right) / 2)
        const segment = array[middle]

        if (this.isSummaryWithinRange(segment.timestamps, target, this.threshold)) {
          return middle
        } else if (target < segment.timestamps) {
          right = middle - 1
        } else {
          left = middle + 1
        }
      }

      return -1
    },

    modifySummaryData(data) {
      // console.log('modifySummaryData', data)
      const modifiedData = data.flatMap((item) => {
        if (!Object.prototype.hasOwnProperty.call(item, 'timestamps')) {
          return []
        }

        if (Array.isArray(item.timestamps)) {
          return item.timestamps.map((ts) => ({
            ...item,
            timestamps: ts,
          }))
        } else {
          return [item]
        }
      })

      // console.log('modifiedData', modifiedData)

      return this.sortSummaryArray(modifiedData)
    },

    sortSummaryArray(data) {
      return data.sort((a, b) => a.timestamps - b.timestamps)
    },

    getPosition(time, duration, elWidth) {
      // console.log('getPosition', time, duration, elWidth)
      let leftValue
      const barFillLocation = (time / duration) * elWidth

      if (barFillLocation - 12 < 0) {
        leftValue = 0
      } else if (barFillLocation > elWidth - 12) {
        leftValue = elWidth - 24
      } else {
        leftValue = barFillLocation - 12
      }
      return leftValue
    },
    getWidth() {
      // console.log('getWidth', this.widthOfVideoControlBar)
      // const xx = document.querySelector('.container-comment-avatar')
      // console.log(xx.getBoundingClientRect())
      // console.log('xx', xx)
      this.$nextTick(() => {
        const getWidth = this.$refs[`avatarContainer-${this.sectionIndex}`]
        this.widthOfVideoControlBar =
          getWidth &&
          getWidth?.getBoundingClientRect() !== undefined &&
          getWidth?.getBoundingClientRect() !== null &&
          getWidth?.getBoundingClientRect()?.width
        return this.widthOfVideoControlBar
      })
    },

    setSeekTime(event) {
      // console.log('setSeekTime', event)

      this.$store.dispatch('setTimeStampSeekTime', event / 1000)
      this.$store.dispatch('setIsRequestSetSeekTime', true)

      // 이 아래 탑으로 올리는것도 필요 없음
      // if (window.innerWidth <= 1263) {
      //   setTimeout(() => {
      //     window.scrollTo({
      //       top: 0,
      //       left: 0,
      //       behavior: 'smooth',
      //     })
      //   }, 10)
      // }
    },

    //Emoji 관련 메소드 🤓 🤓 🤓 🤓 🤓 🤓 🤓 🤓

    async getEmojiList() {
      //사용안함
      // console.log('getEmojiList CommentPlay.vue')
      try {
        let result = await getEmojiList(this, this.currentClip.clipId)
        this.emojiList = result
      } catch (error) {
        console.error('Getting Emojist List Error:', error)
      } finally {
        // console.log('Hello', this.emojiList.visualList)
      }
    },

    showEmojiPlayPreview(time) {
      //이모지 프리뷰 보여주기
      // console.log('showEmojiPlayPreview CommentPlay.vue', time)
      if (!this.$store.getters.emojiPlayPreview) return

      const EMOJI_PREVIEW_DISPLAY_TIME = 0.15

      // if (this.$store.getters.filteredDisplayingEmojiList?.length > 0) {
      for (let i = 0; i < this.emoticonList?.length; i++) {
        if (Math.abs(this.$store.getters.emoticonList[i].emojiTime - time) <= EMOJI_PREVIEW_DISPLAY_TIME) {
          this.$set(this.showEmojiPlay, i, true)

          this.activeEmojiPreviewIdx = i

          if (i > 0) {
            this.$set(this.showEmojiPlay, i - 1, false)
          }

          this.removeEmojiPreview(i)
        } else if (
          Math.abs(this.$store.getters.emoticonList[i].emojiTime - time) < 0.5 &&
          this.$store.getters.emoticonList[i].emojiTime === 0
        ) {
          this.$set(this.showEmojiPlay, i, true)

          this.activeEmojiPreviewIdx = i

          if (i > 0) {
            this.$set(this.showEmojiPlay, i - 1, false)
          }

          this.removeEmojiPreview(i)
        }
      }
    },

    removeEmojiPreview(i) {
      //이모지 프리뷰 제거하기
      // console.log('removeEmojiPreview CommentPlay.vue', i)
      const EMOJI_PREVIEW_DELETE_TIME = 3000

      this.clearTime(this.emojiPreviewTimeOutValue)

      const timer = setTimeout(() => {
        this.$set(this.showEmojiPlay, i, false)
      }, EMOJI_PREVIEW_DELETE_TIME)

      this.emojiPreviewTimeOutValue = timer

      // if (i === this.showEmojiPlay.length - 1) this.$set(this.showEmojiPlay, i, false)
    },

    nudgeLeft(time) {
      let timeStamp = time !== undefined && time !== null && !isNaN(time) ? time : 0
      let position = this.getPosition(timeStamp, this.duration, this.widthOfVideoControlBar)
      let left
      if (position < 70) left = 0
      else if (this.widthOfVideoControlBar - position > 100) left = 80
      else left = 160
      return left
    },

    showEmojiPlayArray() {
      // console.log('showEmojiPlayArray CommentPlay.vue')
      return this.showEmojiPlay
    },

    clickEmoji(emoji, index) {
      //이모지 클릭시
      this.$store.dispatch('setClickcmId', false)
      this.setClickedSummaryCard(null)
      this.setClickedSummaryTimestamp(null)

      if (this.videoControlBarComponent) this.clearTime(this.videoControlBarComponent.timeOutValueForVideoControlBar)

      this.$set(this.showEmojiPlay, this.activeEmojiPreviewIdx, false)

      this.activeEmojiPreviewIdx = index

      // this.$set(this.showEmojiPlay, this.activeEmojiPreviewIdx, false)

      // this.activeEmojiPreviewIdx = index

      if (emoji.emojiTime > 0) {
        let time = emoji.emojiTime * 1000
        this.setSeekTime(time)
      } else {
        this.setSeekTime(0.062)
        // this.setSeekTime(emoji.emojiTime)
      }
      this.$store.dispatch('setIsPauseSeek', false)
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
      this.$store.dispatch('setClickEmojiId', emoji)
      this.$store.dispatch('setIsFadeOut', false)
      this.$store.dispatch('setIsEmojiFadeOut', false)

      this.$store.dispatch('setEmojiPlayPreview', false)
      this.$store.dispatch('setEmojiPlayOn', true)

      this.clearTime(this.emojiPreviewTimeOutValue)

      //check again
      // if (this.boxCommentComponent) this.boxCommentComponent.onEmojiPlay(emoji.emojiTime, 'clicked')
      // if (this.boxCommentComponent) this.boxCommentComponent.currentEmoji = []
      // if (this.boxCommentComponent) this.boxCommentComponent.playEmojiPlay(emoji.emojiTime)
      if (this.boxCommentComponent) this.boxCommentComponent.onRandomAccess(emoji.emojiTime)
    },

    //Comment 관련 메소드 🤓 🤓 🤓 🤓 🤓 🤓 🤓 🤓

    showCommentPlayArray() {
      // console.log('showCommentPlayArray CommentPlay.vue', this.showCommentPlay)
      return this.showCommentPlay
    },

    scrollToHighlightedComment(comment, behavior) {
      //하이라이트 된 커멘트 스크롤 이벤트
      // console.log('scrollToHighlightedComment CommentPlay.vue', comment, behavior)
      if (window.innerWidth <= 1263) return
      if (this.isMobile) return

      this.commentList.forEach((detailComment, detailCommentIndex) => {
        if (detailComment.cmId === comment.cmId) {
          //scroll Event 호출 댓글의 위치로 스크롤 이동
          if (this.detailCommentComponent)
            this.detailCommentComponent.scrollToHighlightedComment(detailCommentIndex, behavior)
        }
      })
    },

    clearTime(timeOutValue) {
      clearTimeout(timeOutValue)
    },

    async removeCommentPlay(index, comment) {
      //Comment Play 중 Comment 제거
      // console.log('removeCommentPlay CommentPlay.vue', index, comment)
      const COMMENT_PLAY_REMOVAL_TIME = 4000

      this.clearTime(this.timeOutValue)
      if (comment.boxData.width !== undefined && comment.boxData.height !== undefined) {
        this.clearTime(this.videoControlBarComponent.timeOutValueForVideoControlBar)
        //새로운 댓글의 존재 시 먼저 이전 댓글이 가지고 있던 fadeOut Animation 값 초기화
        await this.$store.dispatch('setIsFadeOut', false)
        await this.$store.dispatch('setIsFadeOut', true)
      }

      const timer = setTimeout(() => {
        // if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
        if (this.$store.getters.clickCommentId) this.$store.dispatch('setClickcmId', false)
        this.$set(this.showCommentPlay, index, false)
      }, COMMENT_PLAY_REMOVAL_TIME)

      this.$store.dispatch('setCommentPlayTimeOutValue', { timer, index })
      this.timeOutValue = timer
    },

    playCommentPlay(comment, index) {
      //Comment Play에서 커멘트 프리뷰 표시 및 스크롤 이벤트 적용
      // console.log('playCommentPlay CommentPlay.vue')
      // if (this.boxCommentComponent) this.boxCommentComponent.handleCommentPlay(comment)

      //클릭 된 커멘트 카드 스타일링
      this.$store.dispatch('setClickcmId', comment)

      //하이라이트 된 커멘트 스크롤 이벤트
      this.scrollToHighlightedComment(comment, 'smooth')

      //commentPlayPreview 띄우기 그리고 그 전 commentPlayPreview 없애기
      this.$set(this.showCommentPlay, index, true)
      if (index > 0) {
        this.$set(this.showCommentPlay, index - 1, false)
      }
    },

    // playMultiComments() {
    //   console.log('playMultiComments CommentPlay.vue')
    //   this.displayingComments.forEach((comment) => {
    //     if (this.boxCommentComponent) this.boxCommentComponent.handleCommentPlay(comment)
    //   })
    // },

    // addToDisplayingCommentList(item) {
    //   console.log('addToDisplayingCommentList CommentPlay.vue')
    //   if (!item) return

    //   this.displayingComments.push(item)
    // },

    onCommentPlay(time) {
      //Comment Play 시 커멘트 프리뷰 처리
      // console.log('onCommentPlay CommentPlay.vue')
      if (!this.$store.getters.isCommentPlayOn) return
      if (this.iconList && this.iconList !== null) {
        this.iconList.forEach((comment, index) => {
          if (Math.abs(comment.boxData.time - time) < 0.15) {
            // this.addToDisplayingCommentList(comment)

            // this.$store.dispatch('setDisplayingCommentList', this.displayingComments)

            this.playCommentPlay(comment, index)

            this.activeCommentPreviewIdx = index

            //커멘트 플레이 중 3초 후 스타일링 제거 및 박스 그려진거 삭제
            this.removeCommentPlay(index, comment)
          } else if (Math.abs(comment.boxData.time - time) < 0.5 && comment.boxData.time === 0) {
            //만약 댓글의 시간이 0초면 이 로직을 탐
            // this.$store.dispatch('setDisplayingCommentList', comment)
            this.playCommentPlay(comment, index)

            this.activeCommentPreviewIdx = index

            this.removeCommentPlay(index, comment)
          }
        })
      }
    },

    clickControlbarIcon(comment, index) {
      //컨트롤바 아이콘 클릭 시 로직 처리 메소드
      // console.log('clickControlbarIcon', comment, index)
      //꿀렁임 방지를 위해 0.1초 후에 클릭 이벤트 발생
      setTimeout(() => {
        this.setIsCommentIconClicked(comment)
      }, 100)

      // if (!this.isSummaryPlayOn && !this.isPauseIcon) {
      this.setClickedSummaryCard(null)
      this.setClickedSummaryTimestamp(null)
      // }

      if (this.detailCommentComponent && this.isMobile) {
        this.detailCommentComponent.scrollCommentCardMobile(comment, this.commentList)
      } else {
        setTimeout(() => {
          this.scrollToHighlightedComment(comment, 'smooth')
        }, 100)
      }

      if (this.videoControlBarComponent) this.clearTime(this.videoControlBarComponent.timeOutValueForVideoControlBar)
      this.clearTime(this.timeOutValue)
      this.boxCommentComponent.removeBox()
      if (!comment.boxData.width) {
        this.boxCommentComponent.removeBox()
      }

      this.$set(this.showCommentPlay, this.activeCommentPreviewIdx, false)

      this.activeCommentPreviewIdx = index

      this.$store.dispatch('setCommentPlayOn', false)

      // const filteredcmId = this.iconList.filter((boxComment) => {
      //   return boxComment.cmId === comment.cmId
      // })

      // let [videoTime] = filteredcmId

      //버튼이 클릭되면 v-avatar icon이 가지고 있는 time으로 이동
      if (comment.boxData.time > 0) {
        let time = comment.boxData.time * 1000
        this.setSeekTime(time)
      } else {
        this.setSeekTime(0.062)
        // this.setSeekTime(comment.boxData.time)
      }

      if (this.boxCommentComponent) this.boxCommentComponent.handleCommentClickEvent(comment)
      this.$store.dispatch('setClickcmId', comment)
      this.$store.dispatch('setIsFadeOut', false)
      if (this.$store.getters.boxDrawn) {
        this.$store.dispatch('setBoxDrawn', false)
      }
      if (this.boxCommentComponent) this.boxCommentComponent.onCommentRandomAccess(comment.boxData.time)

      // if (this.boxCommentComponent) this.boxCommentComponent.clickToAddOneDisplayingComment(comment)
    },
  },

  computed: {
    modifiedSummaryData() {
      // console.error('Computed 입니다~~~~~~~~~~')
      if (this.summarySegments) {
        // console.error('modifiedSummaryData computed 입니다 🔥: ', this.summarySegments)
        return this.modifySummaryData(this.summarySegments)
      } else {
        // console.error('modifiedSummaryData  ELSE 🚀: ', this.summarySegments)
        return null
      }
    },

    mergedCommentList() {
      let mergedCommentList = [...this.iconList, ...this.emojiList.visualList]

      return mergedCommentList
    },

    ...mapState({
      iconList: (state) => state.comment.controlbarIconList,
      currentClip: (state) => {
        return state.clip.currentClip
      },
      duration: (state) => state.clip.duration,
      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
    }),
    ...mapGetters([
      'emoticonList',
      'clickedSummaryCard',
      'summarySegments',
      'summary',
      'summaryInfo',
      'seekTimeDecimal',
      'clickedSummaryTimestamp',
      'isSummaryPlayOn',
      'isPauseIcon',
      'isFeedback',
    ]),

    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },

    detailCommentComponent() {
      return this.$root.$refs[`DetailComment-${this.sectionIndex}`]
    },

    videoControlBarComponent() {
      return this.$root.$refs[`VideoControlBar-${this.sectionIndex}`]
    },

    commentList() {
      return this.$store.getters.commentList
    },

    isMobile() {
      return isMobile()
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
  },
  watch: {
    isFeedback(val) {
      if (!val) {
        this.widthOfVideoControlBar = this.getWidth()
      }
    },

    // modifiedSummaryData: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal, oldVal) {},
    // },

    // summarySegment: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     console.log('summarySegment', val)
    //   },
    // },

    isPauseIcon(bool) {
      // console.log('isPauseIcon', bool)
      this.setIsSummaryPlayOn(bool)
    },

    seekTimeDecimal(newTime) {
      if (!this.modifiedSummaryData) {
        return
      }

      const summarySegment = this.findSegmentByIndex(this.modifiedSummaryData, newTime)

      if (summarySegment && this.isSummaryPlayOn) {
        // console.log('summarySegment', this.isSummaryPlayOn)
        this.handleSegmentFound(summarySegment)
      }
    },

    // summarySegments(val) {
    //   // Force an update by assigning the same value
    //   // console.error(' summarySegments watched 입니다 : ', val)
    // },

    // summaryInfo(val) {
    //   // console.log('커멘트 플레이!!! summaryInfo watched : ', val)
    // },

    currentClip() {
      this.$store.dispatch('setEmoticonList', null)
      // console.log('currentClip', val)
      this.widthOfVideoControlBar = this.getWidth()

      if (this.boxCommentComponent) this.boxCommentComponent.removeBox()

      if (this.boxCommentComponent) this.boxCommentComponent.initEmojiList()
      if (this.boxCommentComponent) this.boxCommentComponent.resetDisplayingComments()
    },
    clipIndex() {
      this.$store.dispatch('setEmoticonList', null)
    },
    sectionIndex() {
      this.$store.dispatch('setEmoticonList', null)
    },
    iconList(val) {
      if (val !== undefined && val !== null) {
        this.showCommentPlay =
          this.showCommentPlay !== undefined &&
          this.showCommentPlay !== null &&
          this.iconList !== null &&
          this.iconList !== undefined &&
          Array.from({ length: val.length }, () => false)
      }
    },

    emoticonList(val) {
      if (val !== undefined && val !== null) {
        this.showEmojiPlay =
          this.showEmojiPlay !== undefined &&
          this.showEmojiPlay !== null &&
          this.emoticonList !== null &&
          this.emoticonList !== undefined &&
          Array.from({ length: val.length }, () => false)
      }

      this.$store.dispatch('setShowEmojiPlay', this.showEmojiPlay)
    },
    seekTime(val) {
      let time = val / 1000
      this.onCommentPlay(time)
      // this.showEmojiPlayPreview(time)
      // if (this.boxCommentComponent) this.boxCommentComponent.displayEmoji(time)
      // if (this.boxCommentComponent) this.boxCommentComponent.removePlayingEmoji(time)
      if (this.boxCommentComponent) this.boxCommentComponent.displayComments(time)
      if (this.boxCommentComponent) this.boxCommentComponent.removePlayingComments(time)

      // this.playEmojiPlay(time)
      // if (this.boxCommentComponent) this.boxCommentComponent.playEmojiPlay(time)
      // if (this.boxCommentComponent) this.boxCommentComponent.onCommentPlay(time)
      // this.onEmojiPlay(time)
    },
  },
}
</script>

<style scoped>
.v-list-item__content > *:not(:last-child) {
  margin-bottom: 0px;
}
.previewCardDetail {
  border-radius: 5px;
}
.commentPlayPreview {
  background-color: #1d292f;
  border-radius: 5px;
  /* border: 1px solid #475e69; */
  /* animation: fadeout 2.5s infinite; */
}
.v-list {
  border: 1px solid #475e69;
}

.container-comment-avatar {
  position: relative;
  min-height: 25px;
}

.avatarControlbar {
  border: 2px solid #ff575f !important;
  z-index: 10;
  animation: scaleUp 1s 1;
}
.avatarControlbarEmoji {
  /* border: 2px solid #ff575f !important; */
  /* border-radius: 50%; */
  z-index: 1;
  animation: emojiScaleUp 1.5s ease-out infinite alternate;
  /* transform: scale(1.4); */
}
#svgemoji svg {
  background-color: transparent;
  /* background-color: #22323b; */
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes scaleUp {
  0% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes emojiScaleUp {
  0% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1.3);
  }
}
.embeddable .menuable__content__active {
  left: 50% !important;
  transform: translateX(-50%) !important;
}
.hide {
  display: none;
}
</style>
